import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "react-bootstrap";
import { Calendar, Calendar2, CardText, Clock, TextParagraph } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import imageCompression from "browser-image-compression";

export default function PubInfos({ codepub }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [compressing, setCompressin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [suspending, setSuspending] = useState(false);
    const [starting, setStarting] = useState(false);
    const [ending, setending] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [lib, setlib] = useState("");
    const [desc, setdesc] = useState("");
    const [redirection, setredirection] = useState("");
    const [duree, setduree] = useState("");
    const [datedeb, setdatedeb] = useState("");
    const [datefin, setdatefin] = useState("");
    const [revendeur, setrevendeur] = useState('');
    const [revendeursList, setrevendeursList] = useState([]);
    const [picture, setPicture] = useState('');
    const [pictureprev, setPictureprev] = useState('/assets/imgs/no-image.png');
    const [unite, setUnite] = useState({ label: "Jour (s)", value: "days" });

    const unites = [
        {
            label: "Jour (s)",
            value: "days",
        },
        // {
        //     label: "Mois",
        //     value: "months",
        // },
    ];

    const [datecrea, setDatecrea] = useState("");
    const [etat, setEtat] = useState(0);
    const [etatdef, setetatdef] = useState("");


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getRevendeursList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            // if (element.abrevtypeutilisateur === "RVD") {
                            //     clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });
                            // }
                            clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });

                        });

                        setrevendeursList(clientarraydata);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            console.log("error get reventeurs list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/advertisements/${codepub}?page=0`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let body = data?.body?.data[0];
                        let dureee = body?.duree.split(" ");
                        // let qj = body?.qtelimitjour.split(" ");

                        // setprix(body?.prix !== null ? Number.parseInt(body?.prix) : "");

                        setlib(body?.lib !== null ? body?.lib : "");
                        setdesc(body?.descr !== null ? body?.descr : "");
                        setredirection(body?.redirect !== null ? body?.redirect : "");

                        setduree(body?.duree !== null ? dureee[0] : "");
                        setUnite(body.duree !== null ? {
                            label:
                                dureee[1] === "année(s)"
                                    ? "Année (s)"
                                    : dureee[1] === "mois"
                                        ? "Mois"
                                        : dureee[1] === "jour(s)"
                                            ? "Jour (s)"
                                            : "",
                            value: dureee[1] === "année(s)"
                                ? "years"
                                : dureee[1] === "mois"
                                    ? "months"
                                    : dureee[1] === "jour(s)"
                                        ? "days"
                                        : "",
                        } : "");

                        setrevendeur(
                            body?.coderevendeur ? { label: body?.nomuser + " " + body?.prenom, value: body?.coderevendeur, } : ""
                        );
                        setPictureprev(body?.img !== null ? body?.img : "/assets/imgs/no-image.png");
                        setEtat(body?.etat !== null ? body?.etat : 0);
                        setetatdef(body?.etatdef !== null ? body?.etatdef : "Etat");

                        // setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDatecrea(
                            body?.datecrea !== null
                                ? body?.datecrea.slice(0, 16).replace("T", " à ")
                                : ""
                        );
                        setdatedeb(
                            body?.datedeb !== null
                                ? body?.datedeb.slice(0, 16).replace("T", " à ")
                                : ""
                        );
                        setdatefin(
                            body?.datelim !== null
                                ? body?.datelim.slice(0, 16).replace("T", " à ")
                                : ""
                        );

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    const handlepicturechange = (e) => {
        const file = e.target.files[0];
        setPicture(file)
        TransformPicture(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformPicture = async (file) => {
        const reader = new FileReader();

        const options = {
            maxSizeMB: config.app.maxsizefileoption,
            maxWidthOrHeight: 500,
            useWebWorker: true
        };

        if (file) {
            if (file.size > config.app.maxsizefile * 1024) {
                setCompressin(true);
                await imageCompression(file, options).then((img) => {
                    reader.readAsDataURL(img);
                    reader.onloadend = () => {
                        setPictureprev(reader.result);
                    };
                });
                setCompressin(false);
            } else {
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    setPictureprev(reader.result);
                };
            }

        } else {
            setPictureprev("/assets/imgs/no-image.png");
        }
    };

    // comportements
    useEffect(() => {
        getElement();
        getRevendeursList();
    }, []);

    const handleDelete = async () => {
        confirmAlert({
            title: textes.fr.deletepublicitelabel,
            message: textes.fr.deletepublicitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);


                        var requestOptions = {
                            method: "DELETE",
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: "follow",
                        };

                        // console.log("data send", urlencoded);

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/advertisements/${codepub}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage(textes.fr.publicitedeletedlabel);
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }
                        })
                            .catch((err) => {
                                // console.log("error", err);
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editpublicitelabel,
            message: textes.fr.editpublicitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (lib) urlencoded.append("lib", lib);
                        if (desc) urlencoded.append("descr", desc);
                        if (redirection) urlencoded.append("redirection", redirection);
                        urlencoded.append("datedeb", datedeb);
                        if (duree && unite) urlencoded.append("duree", duree + " " + unite["value"]);
                        if (picture || pictureprev !== '/assets/imgs/no-image.png') urlencoded.append("img", pictureprev);
                        urlencoded.append("coderevendeur", (user?.isFullAction || user?.isAdminAction) ? revendeur["value"] : user?.codeutilisateur);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);
                        urlencoded.append("etatdef", etatdef);
                        // console.log("data send", urlencoded)

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/advertisements/${codepub}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage(textes.fr.publiciteupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setFetching(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSuspende = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editpublicitelabel,
            message: textes.fr.editpublicitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setSuspending(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Suspendu");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/advertisements/${codepub}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.publiciteupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setSuspending(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setSuspending(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setSuspending(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setSuspending(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleStart = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editpublicitelabel,
            message: textes.fr.editpublicitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setStarting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "1");
                        urlencoded.append("etatdef", "Publiée");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/advertisements/${codepub}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.publiciteupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setStarting(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setStarting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setStarting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setStarting(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleEnd = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editpublicitelabel,
            message: textes.fr.editpublicitelabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setending(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "3");
                        urlencoded.append("etatdef", "Achevée");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/advertisements/${codepub}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.publiciteupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setending(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setending(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setending(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setending(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        {(user?.isFullAction || user?.isModifierPublicite) && !editedstate && etat === 1 && (
                                            <button
                                                onClick={() => setEditedstate(true)}
                                                title={textes.fr.editpublicitelabel}
                                                className="btn-shadow ml-3 btn btn-success btn-sm float-right"
                                            >
                                                <i className="fa fa-edit mr-1"></i>{" "}
                                                <span>{textes.fr.edit}</span>
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isSupprimerPublicite) && !editedstate && etat === 1 && (
                                            <button
                                                onClick={handleDelete}
                                                title={textes.fr.deletepublicitelabel}
                                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                            >
                                                <i className="fa fa-trash mr-1"></i>{" "}
                                                <span>{textes.fr.delete}</span>{" "}
                                                {deleting && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isActiverPublicite) && !editedstate && etat === 3 && <button onClick={handleStart}
                                            title="Réactiver la publicité"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-arrow-up mr-1"></i> <span>Activer</span>  {starting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isSuspendrePublicite) && !editedstate && etat === 1 && <button onClick={handleSuspende}
                                            title="Suspendre la publicité"
                                            className="btn-shadow ml-3 btn btn-warning btn-sm float-right">
                                            <i className="fa fa-arrow-down mr-1"></i> <span>Suspendre</span>  {suspending && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isAcheverPublicite) && !editedstate && (etat === 1 || etat === 3) && <button onClick={handleEnd}
                                            title="Achever la publicité"
                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                            <i className="fa fa-clock mr-1"></i> <span>Achever</span>  {ending && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        <h5 className="m-0 ">
                                            {textes.fr.publiciteinfoslabel}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form
                                            style={{ width: "100%" }}
                                            className="mb-3"
                                            onSubmit={handleSubmitEdit}
                                        >
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <div className="row">
                                                        {editedstate && <div className="col-md-12 mb-2">
                                                            <label htmlFor="logo" className="form-label">Image illustrative</label>
                                                            <input className="form-control" type="file" id="logo" onChange={handlepicturechange} />
                                                        </div>}
                                                        {compressing && <div className="col-md-12 p-5 mb-3">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="lg"
                                                                role="status"
                                                                aria-hidden="true"
                                                                style={{ display: "block", marginLeft: 'auto', marginRight: 'auto' }}
                                                            />
                                                        </div>}
                                                        {!compressing && <div className="col-md-12 mb-3">
                                                            <img alt="" src={pictureprev} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                        </div>}
                                                    </div>
                                                </div>
                                                <div className="col-md-8 mb-3">
                                                    <div className="row">
                                                        {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                            <label htmlFor="revendeur" className="mb-1">
                                                                {textes.fr.revendeurlabel}
                                                            </label>
                                                            <Select
                                                                id="revendeur"
                                                                name="revendeur"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={revendeursList}
                                                                value={revendeur}
                                                                onChange={(selected) => {
                                                                    setrevendeur(selected);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>}
                                                        {/* <div className="col-md-6 mb-3">
                                                            <label htmlFor="lib" className="mb-1">
                                                                Libelle
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="lib"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={lib}
                                                                    onChange={(e) =>
                                                                        setlib(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div> */}
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="redirection" className="mb-1">
                                                                Lien de redirection
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="redirection"
                                                                >
                                                                    <CardText />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={redirection}
                                                                    onChange={(e) =>
                                                                        setredirection(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="duree" className="mb-1">
                                                                {textes.fr.durelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="duree"
                                                                >
                                                                    <Clock />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={duree}
                                                                    onChange={(e) =>
                                                                        setduree(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="unite" className="mb-1">
                                                                Unité
                                                            </label>
                                                            <Select
                                                                id="unite"
                                                                name="unite"
                                                                placeholder="Sélectionner l'unité"
                                                                options={unites}
                                                                value={unite}
                                                                onChange={(selected) => {
                                                                    setUnite(selected);
                                                                }}
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="datedeb" className="mb-1">Date début</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="datedeb"
                                                                >
                                                                    <Calendar />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={datedeb}
                                                                    onChange={(e) =>
                                                                        setdatedeb(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="datefin" className="mb-1">Date fin</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="datefin"
                                                                >
                                                                    <Calendar />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={datefin}
                                                                    onChange={(e) =>
                                                                        setdatefin(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-md-12 mb-3">
                                                            <label htmlFor="desc" className="mb-1">
                                                                Description
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="desc"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <textarea
                                                                    className="form-control"
                                                                    placeholder={
                                                                        textes.fr.descriptionlabel
                                                                    }
                                                                    value={desc}
                                                                    style={{ height: 154 }}
                                                                    onChange={(e) =>
                                                                        setdesc(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div> */}

                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="etat" className="mb-1">Etat</label>
                                                            <div className="input-group flex-nowrap">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    className={`form-control 
                                                                        ${etat === 1 ? "text-white bg-success" :
                                                                            etat === 2 ? "text-white bg-danger" :
                                                                                ""
                                                                        }`}
                                                                    id="etat"
                                                                    value={etatdef}
                                                                    onChange={(e) => setEtat(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="dateadd" className="mb-1">
                                                                {textes.fr.addeddatelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="dateadd">
                                                                    <Calendar2 />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={datecrea}
                                                                    onChange={(e) => setDatecrea(e.target.value)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {editedstate && (
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.editpublicitelabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Modifier</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => setEditedstate(false)}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
